var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { I18nextProvider } from 'react-i18next';
import rewardsI18n from '../../strings/i18n';
import RewardsModalMFE from './index';
var RewardsModal = function (modalProps) {
    var config = modalProps.config;
    useEffect(function () {
        rewardsI18n.changeLanguage(config.lang);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [config.lang]);
    return (_jsx(I18nextProvider, __assign({ i18n: rewardsI18n }, { children: _jsx(RewardsModalMFE, __assign({}, modalProps)) })));
};
export default RewardsModal;
